<section class="index-banner-inner pad" style="background-image: url(assets/images/pricing.jpg);">
	<div class="container-fluid">
		<div class="container">
			<h2 class="title-banner mbtm20"> Product Pricing </h2>
			<!-- <div class="button-blue"><a href="#">
					<strong>Book For Demo</strong>
				</a>
			</div> -->
		</div>
	</div>
</section>

<!-- <section class="pricing-area">
	<div class="container"> -->
		<!-- <div class="row mt2em row-flex"> -->
		<!-- <div class="row row-flex">
			<div class="col-md-12">
				<h2 class="text-center">
					<span></span><br>Our Packages Pricing <br><br>
				</h2>
			</div>
		</div>
		<div class="row row-flex">
			<div class="col-lg-4 col-md-6" style="margin-top:10px; overflow-wrap: break-word;" *ngFor="let package of packages;">
				<div class="single-pricing-box val">
					<div class="price" [innerHTML] = "'$ '+package.price"> </div>
					<div class="pricing-header">
						<h3 [innerHTML] = "package.packageName"> </h3>
					</div>
					<p>(Rs. <span [innerHTML] = "package.price * package.rupeesValue"></span> approximately)</p>
					<div class="pricing-btn">
						<a routerLink="/tenant-registration/{{ package.id }}" class="default-btn">
							Choose Plan
							<span></span>
						</a>
					</div><hr>
					<div [innerHTML] = "package.packageDesc"></div>
					
				</div>
			</div>
		</div>
	</div>
</section> -->
    <style>
        .contain {
            position: relative;
            /* //  width: 50%; */
        }

        .image {
            display: block;
            width: 100%;
            height: auto;
        }

        .overlay {
            position: absolute;
            bottom: 100%;
            /* //left: 0;
            //right: 0; */
            background-color: #0685d4;
            overflow: hidden;
            width: 92.5%;
            height: 0;
            transition: .5s ease;
            border-radius: 4px;
            cursor: pointer;

        }

        .contain:hover .overlay {
            bottom: 0;
            height: 100%;
        }

        .text {
            color: white;
            font-size: 20px;
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            text-align: center;
        }

        video#bgVideo {
            /* position: absolute; // Play the video in full screen mode */
            top: 0px;
            left: 0px;
            min-width: 100%;
            min-height: 100%;
            /* z-index: -1; // Put the video behind all other elements */
        }
		.slide {
            height: 100%;
            background-color: #fff;
            border: 1px solid #ddd;
            /* padding: 10px; */
            -webkit-box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 5px 10pxrgba(0, 0, 0, 0.2);
        }

        .pricing-slide {
            width: 100%;
            margin: 0px auto;
        }

        .slick-slide {
            margin: 0px 10px;
        }

        .slick-slide img {
            width: 100%;
        }

        .slick-prev:before,
        .slick-next:before {
            color: #94b8ec;
        }


        .slick-slide {
            transition: all ease-in-out .3s;
            opacity: .2;
        }

        .slick-active {
            opacity: 1;
        }

        .slick-current {
            opacity: 1;
        }
    </style>
	<section class="trustes-customers pricing-area">
        <div class="container">
            <div class="row text-center justify-content-center">
				<div class="col-lg-12">
					<h4 class="mb-5 font-weight-bold ">ILMS Package<small></small></h4>
					<img src="assets/images/deployment_option.png" alt="" style="width:400px; height: auto;">
				</div>
				 <div class="col-lg-12 mt2em">
                    <a class="btn btn-info btn-md my-4" type="text" routerLink="/tenant-registration/1">BUY NOW</a>
                </div>
			</div>
			<hr>
			<div class="row text-center justify-content-center">
				<div class="col-lg-12 mt2em">
					<h4 class="mb-5 font-weight-bold ">ILMS Cloud Package<small></small></h4>
				</div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>STANDARD Version</h3>
                        </div>
                       <ul class="pricing-features ILMS_list">
                            <li>
                                Product with defined 3 user license
                            </li>
                            <li>
                                Online Support for a Year
                            </li>
                            <li>
                                99.9% application availability
                            </li>
                            <li>
                                10,000 WhatsApp or SMS, Email based Reports & Notifications
                            </li>
							<li>
                               Includes storage for reports
                            </li>
							<!-- <li> -->
                               <!-- 8x5 online support -->
                            <!-- </li> -->
							<li>
                               Data protection and data backup
                            </li>
							<li>
								Latest software updates
							</li>
                        </ul>
                    </div>
                </div>
				<div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>LITE Version</h3>
                        </div>
                          <ul class="pricing-features ILMS_list">
                            <li>
                                Product with defined 2 user license.
                            </li>
                            <li>
                                Online Support for a Year
                            </li>
                            <li>
                                99.9% application availability
                            </li>
                            <li>
                                3,000 WhatsApp or SMS, Email based Reports & Notifications
                            </li>
							<li>
                               Includes storage for reports
                            </li>
							<li>
                               Data protection and data backup
                            </li>
							<li>
								Latest software updates for 1 year
							</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="single-pricing-box">
                        <!-- <div class="price">
                            <h3>Basic Product</h3>
                        </div> -->
                        <div class="pricing-header" style="background-color: #b6d8fd; padding: 15px 0px 3px 0px;">
                            <h3>Additional add-ons</h3>
                        </div>
                       <ul class="pricing-features ILMS_list">
                            <li> Additional license - 3 users</li>
                            <li> Storage for additional 10,000 reports</li>
                            <li> Unidirectional Device integration</li>
                            <li> Bi-directional device integration</li>
                            <li> One time Configuration</li>
                            <li> Additional Online Training <br> &nbsp;</li>
                        </ul>
                    </div> 
                </div>
                <div class="col-lg-12">
                    <a class="btn btn-info btn-md my-4" type="text" routerLink="/tenant-registration/1">BUY NOW</a>
                </div>
            </div>
        </div>
    </section>
	<!-- <section class="pricing-area"> -->
		<!-- <div class="container-fluid px-3 px-sm-5 my-5 text-center"> -->
			<!-- <h4 class="mb-5 font-weight-bold">Our ILMS Packages<small>(For pricing, please contact us.)</small></h4> -->
			<!-- <div class="regular pricing-slide slider"> -->
				<!-- <div class="slide" *ngFor="let package of packages; let i = index; let first = first ;let last = last;let l = count" > -->
					<!-- <div class="single-pricing-box"> -->
						<!-- <div class="bggray"> -->
                            
                            <!-- <div class="pricing-header"> -->
                                <!-- <h3 [innerHTML] = "package.packageName"> </h3> -->
                            <!-- </div> -->
							
                            <!-- <div class="pricing-btn"> -->
								<!-- <a routerLink="/tenant-registration/{{ package.id }}" class="default-btn"> -->
									<!-- Choose Plan -->
									<!-- <span></span> -->
								<!-- </a> -->
							<!-- </div> -->
                        <!-- </div> -->
						<!-- <div  class="pricing-features" [innerHTML] = "package.packageDesc"></div> -->
					<!-- </div> -->
				<!-- </div> -->
			<!-- </div> -->
		<!-- </div> -->
	<!-- </section> -->
	<!--<section class="pricing-area">
		<div class="container-fluid px-3 px-sm-5 my-5 text-center">
			<h4 class="mb-5 font-weight-bold">Our Packages Pricing</h4>
			<div class="owl-carousel owl-theme">
				<div class="item" *ngFor="let package of packages; let i = index; let first = first ;let last = last;let l = count" [ngClass]="{ first: first, last: last, prev: first, show : i==1, next: i>1 && i<l-1  }" >
					<div class="single-pricing-box">
						<div class="bggray">
                            <div class="price" [innerHTML] = "'$ '+package.price"></div>
                            <div class="pricing-header">
                                <h3 [innerHTML] = "package.packageName"> </h3>
                            </div>
							<p>(Rs. <span [innerHTML] = "package.rupeesValue"></span> approximately)</p>
                            <div class="pricing-btn">
								<a routerLink="/tenant-registration/{{ package.id }}" class="default-btn">
									Choose Plan
									<span></span>
								</a>
							</div>
                        </div>
						<div  class="pricing-features" [innerHTML] = "package.packageDesc"></div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="pricing-area">
        <div class="container-fluid px-3 px-sm-5 my-5 text-center">
            <h4 class="mb-5 font-weight-bold">Our Packages Pricing</h4>
            <div class="owl-carousel owl-theme">
                <div class="item first prev">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $220-1
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>
                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item show">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $120-2
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>
                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="item next">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $220-3
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>

                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="item next">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $220- 4
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>

                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="item next">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $220-5
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>

                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="item last">
                    <div class="single-pricing-box">
                        <div class="bggray">
                            <div class="price">
                                $220-6
                            </div>
                            <div class="pricing-header">
                                <h3>Total Care</h3>
                                <p>Our Pricing Plan Our Pricing Plan</p>
                            </div>
                            <div class="pricing-btn">
                                <a href="#" class="btn-xs default-btn">
                                    Choose Plan
                                    <span></span>
                                </a>
                            </div>
                        </div>

                        <ul class="pricing-features">
                            <li>
                                <i class="las la-check"></i>
                                Complete Blood Count
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Liver Function Blood Test
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Comprehensive Metabolic
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Female general Health Panel
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Transmitted Diaseases
                            </li>
                            <li>
                                <i class="las la-check"></i>
                                Cholesterol Lipid Levels
                            </li>
                        </ul>

                    </div>
                </div>
            </div>
        </div>
    </section> -->
